import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import { LOCALE_PREFIX } from './constants'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import Table from './components/Table'

import './style.scss'
import Counter from '../../../../../../../../../components/Counter'

@hocBlock(config.modules.report.key)
export default class Anotace extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
    }

    render() {
        const { data, id, block, level, module, customData } = this.props
        const localAnnotations = _.get(data, '[0].localAnnotations', 0)

        return (
            <div className={'annotations-block'}>
                <Counter
                    leftValue={{
                        value: localAnnotations,
                    }}
                    description={
                        <FormattedMessage id={`${LOCALE_PREFIX}.numberOfAnnotations`} values={{ br: <br /> }} />
                    }
                />
                <Table id={id} module={module} block={block} level={level} customData={customData} />
            </div>
        )
    }
}
